/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createEnum, EnumSet } from '@gh/core-data';

export const CustomFieldType = createEnum('CUSTOM_FIELD_TYPE', {
  Text: 'TEXT',
  Number: 'NUMBER',
  Date: 'DATE',
});

export type CustomFieldType = EnumSet<typeof CustomFieldType>;
